import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-116e857a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-company-page fade-in" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-content" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Novo Goldylocks"),
    /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Crie aqui uma nova aplicação")
  ])
], -1))
const _hoisted_3 = { class: "progress-steps" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "1", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-label" }, "Dados", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "2", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-label" }, "Contacto", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "3", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-label" }, "Plano", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "form-step" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-building mr-2" }),
    /*#__PURE__*/_createTextVNode(" Dados da Empresa ")
  ])
], -1))
const _hoisted_16 = { class: "card-content" }
const _hoisted_17 = { class: "columns" }
const _hoisted_18 = { class: "column is-6" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "nif-input"
}, "NIF", -1))
const _hoisted_21 = { class: "control has-icons-right" }
const _hoisted_22 = {
  key: 0,
  class: "icon is-small is-right has-text-success"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help" }, "Número de Identificação Fiscal (9 dígitos)", -1))
const _hoisted_26 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_27 = { class: "column is-6" }
const _hoisted_28 = { class: "field" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "alias-input"
}, "Alias", -1))
const _hoisted_30 = { class: "control has-icons-right" }
const _hoisted_31 = {
  key: 0,
  class: "icon is-small is-right has-text-success"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "help" }, "Letras, números, hífens e underscores (3-50 caracteres)", -1))
const _hoisted_35 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_36 = { class: "form-step" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope mr-2" }),
    /*#__PURE__*/_createTextVNode(" Contacto do Responsável ")
  ])
], -1))
const _hoisted_39 = { class: "card-content" }
const _hoisted_40 = { class: "form-step" }
const _hoisted_41 = { class: "card" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cube mr-2" }),
    /*#__PURE__*/_createTextVNode(" Plano a utilizar ")
  ])
], -1))
const _hoisted_43 = { class: "card-content" }
const _hoisted_44 = { class: "field" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "plan-select"
}, "Selecione o plano", -1))
const _hoisted_46 = { class: "control" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  value: "0",
  disabled: ""
}
const _hoisted_49 = ["value"]
const _hoisted_50 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Não foi possível carregar os planos. ")
const _hoisted_52 = {
  key: 0,
  class: "plan-details"
}
const _hoisted_53 = { class: "plan-pricing" }
const _hoisted_54 = { class: "pricing-card" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pricing-label" }, "Mensal", -1))
const _hoisted_56 = { class: "pricing-value" }
const _hoisted_57 = { class: "pricing-card" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pricing-label" }, "Anual", -1))
const _hoisted_59 = { class: "pricing-value" }
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = { class: "form-navigation" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left mr-2" }, null, -1))
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Anterior ")
const _hoisted_64 = [
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Próximo ")
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right ml-2" }, null, -1))
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = ["disabled"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Criar Goldylocks ")
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_AddressFields = _resolveComponent("AddressFields")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createGoldylocks && _ctx.createGoldylocks(...args)), ["prevent"])),
      class: "form-container"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["step", {active: _ctx.currentStep >= 1, completed: _ctx.currentStep > 1}])
        }, _hoisted_6, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step-line", {active: _ctx.currentStep > 1}])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step", {active: _ctx.currentStep >= 2, completed: _ctx.currentStep > 2}])
        }, _hoisted_9, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step-line", {active: _ctx.currentStep > 2}])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["step", {active: _ctx.currentStep >= 3}])
        }, _hoisted_12, 2)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("input", {
                      id: "nif-input",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dadosEmpresa.nif_goldylocks) = $event)),
                      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateNifInput && _ctx.validateNifInput(...args))),
                      class: _normalizeClass(["input", {'is-danger': _ctx.dadosEmpresa.nif_goldylocks && !_ctx.isNifValid, 'is-success': _ctx.isNifValid}]),
                      type: "text",
                      placeholder: "999999999",
                      maxlength: "9",
                      required: ""
                    }, null, 34), [
                      [_vModelText, _ctx.dadosEmpresa.nif_goldylocks]
                    ]),
                    (_ctx.isNifValid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _hoisted_24))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_25,
                  (_ctx.dadosEmpresa.nif_goldylocks && !_ctx.isNifValid)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, "O NIF deve conter exatamente 9 dígitos"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      id: "alias-input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dadosEmpresa.alias_goldylocks) = $event)),
                      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validateAliasInput && _ctx.validateAliasInput(...args))),
                      class: _normalizeClass(["input", {'is-danger': _ctx.dadosEmpresa.alias_goldylocks && !_ctx.isAliasValid, 'is-success': _ctx.isAliasValid}]),
                      type: "text",
                      placeholder: "aminhaempresa",
                      maxlength: "50",
                      required: ""
                    }, null, 34), [
                      [_vModelText, _ctx.dadosEmpresa.alias_goldylocks]
                    ]),
                    (_ctx.isAliasValid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _hoisted_33))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_34,
                  (_ctx.dadosEmpresa.alias_goldylocks && !_ctx.isAliasValid)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_35, "Alias inválido"))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode(_component_FormInput, {
              id: "nome-input",
              label: "Nome empresa",
              modelValue: _ctx.dadosEmpresa.nome_goldylocks,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dadosEmpresa.nome_goldylocks) = $event)),
              placeholder: "Empresa demonstrativa, Lda",
              "max-length": "100",
              required: "",
              "custom-validator": (value) => value.length >= 2 && value.length <= 100
            }, null, 8, ["modelValue", "custom-validator"]),
            _createVNode(_component_FormInput, {
              id: "morada-input",
              label: "Morada",
              modelValue: _ctx.dadosEmpresa.morada_goldylocks,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dadosEmpresa.morada_goldylocks) = $event)),
              placeholder: "Rua de teste, Nº 85",
              "max-length": "150",
              required: "",
              "custom-validator": (value) => value.length >= 5 && value.length <= 150
            }, null, 8, ["modelValue", "custom-validator"]),
            _createVNode(_component_AddressFields, {
              "postal-code": _ctx.dadosEmpresa.cp_goldylocks,
              city: _ctx.dadosEmpresa.localidade_goldylocks
            }, null, 8, ["postal-code", "city"])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.currentStep === 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_FormInput, {
              id: "email-input",
              label: "Email do responsável",
              modelValue: _ctx.dadosEmpresa.email,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dadosEmpresa.email) = $event)),
              type: "email",
              placeholder: "gerencia@empresa.pt",
              "max-length": "100",
              required: "",
              "validation-pattern": /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            }, null, 8, ["modelValue", "validation-pattern"])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.currentStep === 2]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", {
                  class: _normalizeClass(["select is-fullwidth", {'is-loading': _ctx.isLoadingPlans}])
                }, [
                  _withDirectives(_createElementVNode("select", {
                    id: "plan-select",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dadosEmpresa.plan_id) = $event)),
                    disabled: _ctx.isLoadingPlans || _ctx.plansLoadError,
                    required: ""
                  }, [
                    _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.isLoadingPlans ? 'Carregando planos...' : _ctx.plansLoadError ? 'Erro ao carregar planos' : 'Selecione um plano...'), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlyPlans, (plan) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: plan.codigo_plano,
                        value: plan.id_plano
                      }, _toDisplayString(_ctx.sanitizeTextInput(plan.nome_plano)), 9, _hoisted_49))
                    }), 128))
                  ], 8, _hoisted_47), [
                    [_vModelSelect, _ctx.dadosEmpresa.plan_id]
                  ])
                ], 2)
              ]),
              (_ctx.plansLoadError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchPlans && _ctx.fetchPlans(...args)), ["prevent"])),
                      class: "has-text-link"
                    }, "Tentar novamente")
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.dadosEmpresa.plan_id > 0 && _ctx.selectedPlanInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("span", _hoisted_56, "€ " + _toDisplayString(_ctx.selectedPlanInfo['valor_mensal']), 1)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("span", _hoisted_59, "€ " + _toDisplayString(_ctx.selectedPlanInfo['valor_anual']), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "plan-description",
                    innerHTML: _ctx.selectedPlanInfo['designacao_html']
                  }, null, 8, _hoisted_60)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, _ctx.currentStep === 3]
      ]),
      _createElementVNode("div", _hoisted_61, [
        (_ctx.currentStep > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "button is-medium",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.prevStep && _ctx.prevStep(...args)))
            }, _hoisted_64))
          : (_openBlock(), _createElementBlock("div", _hoisted_65)),
        (_ctx.currentStep < 3)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "button is-link is-medium",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args))),
              disabled: !_ctx.canProceed
            }, _hoisted_69, 8, _hoisted_66))
          : _createCommentVNode("", true),
        (_ctx.currentStep === 3)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "submit",
              class: _normalizeClass(["button is-success is-medium", {'is-loading': _ctx.isCreating}]),
              disabled: !_ctx.isFormValid
            }, _hoisted_73, 10, _hoisted_70))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ]))
}